import {parse, isValid} from 'date-fns';

import type {Nullish} from 'shared/web';

import type {Hour, Minute} from '../../../types/TimeType';

/**
 * Splits TimeType value into hours and minutes. Returns null if given invalid or Nullish value.
 */
export const getHoursAndMinutesFromTime = (time: unknown | Nullish) => {
  if (!time) {
    return null;
  }

  // Use a fixed reference date that is never affected by DST transitions
  const REFERENCE_DATE = new Date(2000, 0, 1); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  // Try parsing with different formats
  const formats = ['HH:mm', 'H:m', 'h:mm a', 'h:m a', 'HH.mm', 'HHmm', 'hh:mm a', 'h:mm a'];
  let parsedDate = null;

  for (const format of formats) {
    const attempt = parse(time.toString(), format, REFERENCE_DATE);
    if (isValid(attempt)) {
      parsedDate = attempt;
      break;
    }
  }

  if (!parsedDate) {
    return null;
  }

  const hour = parsedDate.getHours().toString().padStart(2, '0') as Hour;
  const minute = parsedDate.getMinutes().toString().padStart(2, '0') as Minute;

  return {hour, minute};
};
